// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-attachment[data-v-765bd4c8]{margin-left:20px}.v-select-custom[data-v-765bd4c8] .vs__dropdown-toggle{max-width:23em;overflow-x:scroll}", ""]);
// Exports
module.exports = exports;
